<template>
<article class="single-draft-file m-b-30" :class="{responded: ['Yes', 'No'].includes(draft.approvalStatus)}">
  <div class="tickMark" :class="{tickGreen: ['Yes', 'No'].includes(draft.approvalStatus)}">
    <span><i class="fa fa-check" aria-hidden="true"></i></span>
  </div>
  <div class="row">
    <div class="col-md-3 text-center">

      <CoolLightBox :items="images" :index="index" @close="index = null">
      </CoolLightBox>

      <div v-for="(image, imageIndex) in thumbImages" :key="imageIndex" @click="index = imageIndex">

        <b-img :src="image" fluid class="m-b-10 thumbImage" alt="Responsive image"></b-img>

        <div>
          <b-button variant="dark" block>
            <i class="fa fa-search-plus"></i> Click to zoom
          </b-button>

        </div>

      </div>
    </div>
    <div class="col-md-9">

      <section v-if="draft.approvalStatus == 'Not Touched' && hasLinkExpired">
        <b-alert show variant="primary" class="m-b-20">
          <h3>We didn't receive your response within {{timeLimit}} hours, so the artwork is assumed as final.</h3>
        </b-alert>

        <section v-if="draftType == 'digital_print'">
          <p>
            Download the artwork by clicking the button below.
          </p>
          <b-btn @click.prevent="downloadFile(draft.fileInfo.fileUrl)" class="btn btn-success" :disabled="downloadInProgress">
            <b-spinner small v-show="downloadInProgress" class="m-r-10"></b-spinner>
            <span>{{ downloadInProgress ? "Processing Request" : "Download Completed Artwork"}}</span>
          </b-btn>
          <strong class="m-l-15 m-r-15">OR</strong>
          <a :href="draft.fileInfo.fileUrl" target="_blank" @click="saveDownloadInfo('file link')">
            Visit Artwork Link
          </a>
          <p class="m-t-30"><strong>Note regarding download :</strong> If the download button doesn't work for some reason, please visit the link given on the right and download the artwork from there. </p>
        </section>
        <section v-else>
          <p>We will proceed with the printing work.</p>
        </section>

        <feedback-location-indicator v-if="responseCompleteOnAll && !feedbackReceived" />
        
      </section>

      <section v-else-if="draft.approvalStatus == 'Not Touched' && !hasLinkExpired">

        <b-alert show variant="primary"><strong>Important Note :</strong> If you don't respond within {{timeLimit}} hours, the design will be considered as approved.</b-alert>

        <draft-need-change-form :ids="{id: draft.id, customerDraftId: draft.customerDraftId}" :draft-type="draftType" />

      </section>

      <section v-else-if="draft.approvalStatus == 'No'">
        <b-alert show variant="primary">
          <h3>
            We have saved your response.
          </h3>
          We will get back to you soon.
        </b-alert>

        <feedback-location-indicator v-if="responseCompleteOnAll && !feedbackReceived" />
      </section>

      <section v-else-if="draft.approvalStatus == 'Yes'">

        <section v-if="isDownloadableFile">
          <p>
            Download the artwork by clicking the button below.
          </p>
          <b-btn @click.prevent="downloadFile(draft.fileInfo.fileUrl)" class="btn btn-success" :disabled="downloadInProgress">
            <b-spinner small v-show="downloadInProgress" class="m-r-10"></b-spinner>
            <span>{{ downloadInProgress ? "Processing Request" : "Download Completed Artwork"}}</span>
          </b-btn>
          <strong class="m-l-15 m-r-15">OR</strong>
          <a :href="draft.fileInfo.fileUrl" target="_blank" @click="saveDownloadInfo('file link')">
            Visit Artwork Link
          </a>
          <p class="m-t-30"><strong>Note regarding download :</strong> If the download button doesn't work for some reason, please visit the link given on the right and download the artwork from there. </p>
        </section>
        <section v-else>
          <p>We will proceed with the printing work.</p>
        </section>
        <feedback-location-indicator v-if="responseCompleteOnAll && !feedbackReceived" />
      </section>

      

    </div>

  </div>

</article>
</template>

<script>
const DraftNeedChangeForm = () => import( /* webpackChunkName: "draft-need-change-form" */ "./draft-need-change-form.vue")

const FeedbackLocationIndicator = () => import(/* webpackChunkName: "feedback-location-indicator" */ "../feedback/feedback-location-indicator")

// use the component
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import axios from "axios";
import CustomerDraftsService from '../../../services/customer-drafts.service'
import moment from 'moment';

export default {
  data() {
    return {
      showChangeForm: false,
      images: [],
      thumbImages: [],
      index: null,
      downloadInProgress: false,
      timeLimit: 48
    }
  },
  props: {
    draft: {
      type: Object,
      default: () => ({})
    },
    ip: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: ''
    },
    hasLinkExpired: {
      type: Boolean,
      default: false
    },
    draftType: {
      type: String,
      default: ''
    },
    responseCompleteOnAll: {
      type: Boolean,
      default: false
    },
    feedbackReceived: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.images.push(this.draft.fileInfo.fileUrl);
    this.thumbImages.push(this.draft.fileInfo.fileThumbUrl);
  },
  // watch: {
  //   draft: {
  //     handle(newValue, oldValue) {
  //       this.images.push(newValue.fileInfo.fileThumbUrl)
  //       this.thumbImages.push(this.draft.fileInfo.fileThumbUrl);
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    downloadFile(fileLink) {
      var filename = fileLink.replace(/^.*[\\\/]/, '')
      this.downloadInProgress = true;
      axios({
          url: `${fileLink}?${Date.now()}`,
          method: 'GET',
          responseType: 'blob', // important
        }).then(async (response) => {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          await this.saveDownloadInfo("download button");

        })
        .catch(e => {
          console.log(e);
        })
        .then(() => {
          this.downloadInProgress = false;
        })
    },
    async saveDownloadInfo(downloadType = "") {

      try {
        let data = {
          id: this.draft.id,
          customerDraftId: this.draft.customerDraftId,
          ip: this.ip ? this.ip : '',
          timezone: this.timezone ? this.timezone : '',
          downloadType
        }
        await CustomerDraftsService.saveDownloadInfo(data);

      } catch (e) {
        console.log('Download log error', e)
      }
    }
  },
  components: {
    DraftNeedChangeForm,
    CoolLightBox,
    FeedbackLocationIndicator
  },
  computed:{
    isDownloadableFile(){
       if(this.draftType == 'digital_print'){
         return true;
       }else if(this.draft.fileInfo.fileUrl.toLowerCase().includes('digital')){
          return true;
       }else{
         return false;
       }
    }
  }
}
</script>

<style lang="scss" scoped>
$orangeColor: rgb(255, 95, 21);
$tickColor: rgb(15, 175, 36);
.single-draft-file {
  border: 1px solid rgb(212, 212, 212);
  padding: 20px;
  border-radius: 5px;
  position: relative;
}

.thumbImage {
  cursor: pointer;
}
.tickMark{
  left: -30px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  position: absolute;
  background-color: rgb(214, 214, 214);
  border-radius: 3px 0 0 3px;
  color: rgb(128, 128, 128);
}
.tickGreen{
  color: #fff;
  background-color: $tickColor;
}
.responded{
  border: 1px solid $tickColor;
}
</style>
